import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HTML_ERRORS } from '@commoncore/constants/htmlErrors';
import { GlobalService } from '@commoncore/services/global.service';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

@Component({
  standalone:true,
  selector: 'lib-not-supported',
  templateUrl: './not-supported.component.html',
  styleUrls: ['./not-supported.component.scss'],
  imports:[DependenciesModule]
})
export class NotSupportedComponent implements OnInit {
  public isWindows:boolean = false;
  public isMac:boolean = false;
  public isIOS:boolean = false;
  public isAndroid:boolean = false;
  public universalService:any;
  public router: Router;
  public shareKey:any={};
  public showNotSupportedBanner : boolean = false;
  @Input() browserSupported:boolean = false;
  @Input() viewType = "";
  bannerMessage: string="";

  constructor(public globalService:GlobalService, public route:ActivatedRoute) { 
    this.setEnvObjects(this.globalService);
    // if(this.universalService.activeRepo == "share")
    //   this.getQueryParamsIfAny();
  }

  ngOnInit(): void {
    this.showMessageBasedOnOSType();
    // this.setDeviceType();
    // this.universalService.hideLeftMenu = true;
  }

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.router = this.globalService.getRouterRef();
  }


  showMessageBasedOnOSType(){
    if(this.universalService.deviceType == "macOS" || (this.universalService.isMobileDevice && this.universalService.iOSdevice)){
      this.bannerMessage = HTML_ERRORS["MAC_NOT_SUPPORTED_MESSAGE"]
    }else{
      this.bannerMessage = HTML_ERRORS["WINDOWS_NOT_SUPPORTED_MESSAGE"]
    }
      
  }
}
